module.exports = __webpack_public_path__ + "img/paw-square-white-d2a0cfb.png";